// Independent page composition for Data Governance Services.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function DataGovernancePage({ service }) {
  return h(PageFrame, { service, tone: 'split', hero: diagram(service, 'collaboration') },
    section('Clear ownership across people and systems', split(context(service), scope())),
    section('Agree how the work will run', deliverables(service)),
    section(null, split(answer(service), scenario(service)), { theme: 'ai-wash' })
  );
};
